
import { useState } from 'react';

export default function Testimonials() {
  const testimonials = [
    {
      rating: 5.0,
      quote: "Nexora Solutions transformed our online presence completely. Within two weeks of launching our new website, we saw a 300% increase in customer inquiries. The demo-first approach gave us confidence before committing, and the final product exceeded all expectations.",
      name: "Michael Rodriguez",
      title: "Owner, Rodriguez Plumbing Services",
      avatar: "https://public.readdy.ai/ai/img_res/f1c127f0f4b75d54758ba9c30e8d33cd.jpg"
    },
    {
      rating: 5.0,
      quote: "The team at Nexora delivered exactly what they promised. Our demo website was ready in just 5 days, and after a few minor tweaks, we went live. We've been getting calls from new customers every single day since launch. Best investment we've made for our business.",
      name: "Sarah Chen",
      title: "Founder, Chen's Auto Repair",
      avatar: "https://readdy.ai/api/search-image?query=professional%20asian%20female%20business%20owner%20in%20her%2030s%20wearing%20professional%20attire%20smiling%20warmly%20in%20bright%20modern%20workspace%20clean%20background&width=120&height=120&seq=testimonial-avatar-2&orientation=squarish"
    },
    {
      rating: 5.0,
      quote: "I was skeptical about getting a website, but Nexora made it so easy. No upfront costs, they showed me the demo first, and I could see exactly what I was getting. Now my landscaping business looks as professional online as we are in person. Highly recommend!",
      name: "James Thompson",
      title: "Owner, Thompson Landscaping",
      avatar: "https://readdy.ai/api/search-image?query=professional%20caucasian%20male%20business%20owner%20in%20his%2050s%20wearing%20polo%20shirt%20smiling%20genuinely%20outdoor%20setting%20natural%20background%20professional%20headshot&width=120&height=120&seq=testimonial-avatar-3&orientation=squarish"
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const current = testimonials[currentIndex];

  return (
    <section className="relative py-32 bg-[#050a14] overflow-hidden">
      <div className="relative z-10 max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <i className="ri-double-quotes-l text-5xl text-[#1e3a8a]"></i>
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-white">What Clients Say</h2>
        </div>

        <div className="relative bg-[#0a1628] rounded-3xl p-12 lg:p-16 shadow-2xl shadow-[#1e3a8a]/5 border border-[#1e3a8a]/20">
          <div className="mb-8">
            <div className="inline-flex items-center gap-2 bg-[#0a1628] border border-[#1e3a8a]/30 px-4 py-2 rounded-full">
              <i className="ri-star-fill text-white"></i>
              <span className="text-white font-semibold">{current.rating}</span>
            </div>
          </div>

          <blockquote className="text-2xl lg:text-3xl text-white font-light italic leading-relaxed mb-12">
            &ldquo;{current.quote}&rdquo;
          </blockquote>

          <div className="flex items-center gap-6">
            <div className="w-16 h-16 rounded-full overflow-hidden ring-4 ring-[#1e3a8a]/30 flex-shrink-0">
              <img 
                src={current.avatar} 
                alt={current.name}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <div className="text-xl font-bold text-white">{current.name}</div>
              <div className="text-white/70">{current.title}</div>
            </div>
          </div>

          <div className="absolute bottom-12 right-12 flex items-center gap-3">
            <button 
              onClick={handlePrev}
              className="w-14 h-14 border-2 border-[#1e3a8a]/30 hover:border-[#1e3a8a] rounded-xl flex items-center justify-center text-white/70 hover:text-white transition-all duration-300 cursor-pointer"
              aria-label="Previous testimonial"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            <button 
              onClick={handleNext}
              className="w-14 h-14 bg-[#0a1628] border border-[#1e3a8a]/50 hover:border-[#1e3a8a] rounded-xl flex items-center justify-center text-white transition-all duration-300 cursor-pointer shadow-lg shadow-[#1e3a8a]/10"
              aria-label="Next testimonial"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
